import { useGT } from 'gt-react';
import type { ArTasksTab } from '@erp/rpc';
import { arTasksTabLabel } from './arTasksPageState';

/**
 * Segmented tabs, styled like the cash receipts page's Open/Completed/All,
 * each with its open-task count (unfiltered, like the metric cards).
 */
export function ArTasksTabs({
  value,
  counts,
  onChange,
}: {
  value: ArTasksTab;
  /** Absent while the summary loads; badges are hidden until then. */
  counts: Record<ArTasksTab, number> | undefined;
  onChange: (tab: ArTasksTab) => void;
}) {
  const gt = useGT();
  const tabs = (['all', 'to_invoice', 'to_send'] as const).map((key) => ({
    key,
    label: arTasksTabLabel(key, gt),
  }));
  return (
    <div className="flex w-fit items-center gap-2 rounded-lg bg-muted p-1">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className={`flex cursor-pointer items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            value === t.key
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          onClick={() => onChange(t.key)}
        >
          {t.label}
          {counts && (
            <span className="text-xs tabular-nums text-muted-foreground">
              {counts[t.key]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
